import $ from "jquery";
import { Spinner, SkeletonLoader } from "components/shared";
import taskSoundNotification from "assets/audio/new-task-notif.mp3"
import { INTERVENTION_STATUS } from "utils"
import { AGENT_STATUS } from "./constants";

class Utils {

    //SCROLL CONVERSATION CONTAINER TO BOTTOM
    scrollChatContainerToBottom = () => {
        $(document).ready(() => {
            $('.conversation-scroll').scrollTop($('.conversation-scroll').prop("scrollHeight") ** 5);
        });
    }

    //FIX CONTAINERS OVELAPPING ISSUE
    fixComposerOverlpping = () => {
        $(document).ready(() => {
            //fix composer width
            var parentWidth = $('.root-conversation').width();
            $('.composer-content').width(parentWidth);
            //fix conversation height
            var composerHeight = $('.composer-content').height() ? $('.composer-content').height() : 0;
            var rootContainerheight = $('.root-conversation').height();
            $('.conversation-scroll').height(rootContainerheight - composerHeight - 110);
        });
    }

    //GET NESTED OBJECT
    getNestedObject = (nestedObj, pathArr) => {
        return pathArr.reduce((obj, key) =>
            (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    }

    //ASC ARRAY SORTING BASED CUSTOM ATT
    sortArrayObjectByDateASC = (data, keys) => {
        let getNestedObj = (obj, keys) => this.getNestedObject(obj, keys);
        const sorted = data.sort(function (a, b) {
            return new Date(getNestedObj(a, keys)) - new Date(getNestedObj(b, keys));
        });
        return sorted;
    }

    //DESC ARRAY SORTING BASED CUSTOM ATT
    sortArrayObjectByDateDESC = (data, keys) => {
        let getNestedObj = (obj, keys) => this.getNestedObject(obj, keys);
        const sorted = data.sort(function (a, b) {
            return new Date(getNestedObj(b, keys)) - new Date(getNestedObj(a, keys));
        });
        return sorted;
    }

    //CHECKING AN ARRAY IF IT CONTAINS AN OBJECT BASED SPECIFIC ATT
    isArrayIncludesObject = (array, metaValue, value) => {
        return array?.findIndex(x => x[metaValue] === value) === 1;
    }

    //GET AN OBJECT FROM AN ARRAY BASED CUSTOM ATT
    getObjectFromArray = (array, metaValue, value) => {
        return array && array[array?.findIndex(x => x[metaValue] === value)];
    }

    //GET INDEX FROM AN ARRAY BASED SPECIFIC CUSTOM ATT
    getIndexObjectFromArray = (array, metaValue, value) => {
        return array?.findIndex(x => x[metaValue] === value);
    }

    //CONVERT UPLOADED FILE TO BASE64
    fileToBase64 = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result.split(',')[1]);
        };
        reader.onerror = (error) => {
            reject(error);
        };
    })

    //GUESSING MESSAGE SOURCE ICON
    guessSourceIcon = (source) => {
        switch (source) {
            case ('messenger'): {
                return "bi bi-messenger";
            }
            case ('linkedin'): {
                return "bi bi-linkedin";
            }
            case ('instagram'): {
                return "bi bi-instagram";
            }
            case ('twitter'): {
                return "bi bi-twitter";
            }
            case ('facebook'): {
                return "bi bi-facebook";
            }
            default: {
                break;
            }
        }
    }

    guessStatusIcon = (statusId) => {
        switch (statusId.toLowerCase()) {
            case (INTERVENTION_STATUS.INITIATED): {
                return { icon: "bi bi-bookmark-plus", color: "secondary" }
            }
            case (INTERVENTION_STATUS.ACCEPTED): {
                return { icon: "bi bi-bookmark-check", color: "primary" }
            }
            case (INTERVENTION_STATUS.IN_PROGRESS): {
                return { icon: "bi bi-hourglass-top", color: "danger" }
            }
            case (INTERVENTION_STATUS.COMPLETED): {
                return { icon: "bi bi-check-circle", color: "success" }
            }
            case (INTERVENTION_STATUS.ARCHIVED): {
                return { icon: "bi bi-archive", color: "warning" }
            }
            case (INTERVENTION_STATUS.ABORTED): {
                return { icon: "bi bi-x-circle", color: "secondary" }
            }
            case (INTERVENTION_STATUS.DEFFERRED): {
                return { icon: "bi bi-arrow-up-right-circle", color: "secondary" }
            }
            default: {
                return {}
            }
        }
    }

    //SHORTAND CHARCTER CHAIN
    shorthandString = (str, size = 25) => {
        return str?.length > size ? `${str.substring(0, size)}...` : str;
    }

    //CHECK IF CHARACTER CHAIN IS SO LONG
    isLongText = (str) => {
        return str?.length > 15;
    }

    //CONVERTING DATE
    convertDate(inputFormat) {
        var d = new Date(inputFormat);
        function pad(s) {
            return (s < 10) ? '0' + s : s;
        }
        return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDay())].join('-')
    }

    //CONVERT DATE INTO TIME
    convertDateTime = (doubleDate) => {
        var d = new Date(doubleDate);
        function pad(s) {
            return (s < 10) ? '0' + s : s;
        }
        // var time=[ pad(d.getHours()),pad(d.getMinutes())].join(':')
        var date = [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDay())].join('/');
        return date;
    }

    formatDateSu(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    formatDate(d) {
        function pad(s) {
            return (s < 10) ? '0' + s : s;
        }
        return [pad(d.getDay()), pad(d.getMonth() + 1), d.getFullYear()].join('-')
    }

    //LABEL TEMPLATE WITH PROGRESS SUBMIT
    labelTemplate = (template, loading, label) => {
        return loading ? <Spinner color="white" sm label={label} size="22px" /> : template;
    }

    //FULFILL & PREVENT EMPTY ARGUMENTS
    fullFilledArrayArguments = (args) => {
        let notNullArgs = true;
        args.map(item => { if (item === null) notNullArgs = false; return item });
        return notNullArgs;
    }

    //FIX CONTAINER OVERLAPPING BASED CUSTOM CLASS
    fixContainersOverlaping = (className) => {
        let height = $(".root-conversation").height() - 180;
        $(className).height(height);
    }

    //CONVERT MS INTO TIMES UNITS
    msToDHMS(milliSeconds) {
        var seconds = Number(milliSeconds / 1000);
        var d = Math.floor(seconds / (3600 * 24));
        var h = Math.floor(seconds % (3600 * 24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60);
        var dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
        var hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
        var mDisplay = m > 0 ? m + (m === 1 ? " minute, " : " minutes, ") : "";
        var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "0 seconds";
        return dDisplay + hDisplay + mDisplay + sDisplay;
    }

    msToDHMSBis(milliSeconds, dhm) {
        var seconds = Number(milliSeconds / 1000);
        var d = Math.floor(seconds / (3600 * 24));
        var h = Math.floor(seconds % (3600 * 24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60);
        var dDisplay = d > 0 ? d + (d === 1 ? " d, " : " d, ") : "";
        var hDisplay = h > 0 ? h + (h === 1 ? " H, " : " H, ") : "";
        var mDisplay = m > 0 ? m + (m === 1 ? " min, " : " min, ") : "";
        var sDisplay = s > 0 ? s + (s === 1 ? " s" : " s") : "0 s";
        return dDisplay + hDisplay + mDisplay + (!dhm ? sDisplay : ``);
    }

    //SET ELEMENT HEIGHT
    assignHeightToElement = (element, height) => {
        $(element).height(height);
    }

    //FIRE NOTIFICATION AUDIO
    playAudioNotification = () => {
        new Audio(taskSoundNotification).play();
    }

    //FIX ALERT OVERLAPPING WITHIN ROOT CONTENT
    fixErrorAlertOverlaping = () => {
        $(".root-content").css("margin-top", $(".error-socket-boundary").height());
    }

    //UPDATE URL WITH SEARCH PARAMETER
    pushURLSearchParams = (history, param, value) => {
        var url = new URL(window.location.href);
        var search_params = url.searchParams;
        search_params.set(param, value);
        url.search = search_params.toString();
        var new_url = history.location.pathname + url.search;
        history.push(new_url);
    }

    //FILTER ARRAY BY STATUS PROPERTY
    filterArrayBasedStatus = (array, id, include) => {
        return array?.filter(item => include ? item['status']['statusId'] === id : item['status']['statusId'] !== id)
    }

    //FILTER ARRAY BY SETP PROPERTY
    filterArrayBasedStepChrnology = (array, id, include) => {
        return array?.filter(item => include ? item['step']['stepId'] === id : item['step']['stepId'] !== id)
    }

    //RETRIEVE OBJECT FROM SEARCH QUERY
    getObjectFromSearchQuery = (history, key) => {
        return JSON.parse(new URLSearchParams(history.location.search).get(key));
    }

    //PREVIEW FRAME TEMPLATE
    ImagePreviewContainer = (imageSource, ratio = 300, translateY = 40, label = null) => {
        return <div className="text-center" style={{ transform: `translateY(${translateY}%)` }}>
            <img src={imageSource} alt="preview" width={ratio} className="img-fluid" />
            {label && <div className="my-3" style={{ fontSize: "20px" }}>{label}</div>}
        </div>
    }

    //VALIDATE START & EN DATES
    validateRengeDates = (startDate, endDate) => {
        return (!startDate && !endDate) ? true : new Date(startDate).getTime() < new Date(endDate).getTime();
    }

    //RETRIEVE FILE NAME FROM CDN LINK
    retrieveFileNameFromURL = (url) => {
        let fileName = url?.split("/")[6]?.split("?")[0];
        return fileName ? fileName : "Attachment file";
    }

    //NO ITEMS TEMPLATE CONTENT
    NoItemsTemplate = () => {
        return (
            <div className="text-center m-3">
                <i className="bi bi-exclamation-circle" style={{ fontSize: "30px" }} /><br />
                <span>No items found</span>
            </div>
        )
    }

    //CONSTRUCT FILTER EXPRESSION FROM EMBEDDED OBJECT
    buildFilterCriteria = (filterObject) => {
        filterObject = filterObject ? filterObject : {};
        let filter = ``;
        Object.keys(filterObject).forEach((item) => {
            if (filterObject[item]) {
                filter = `${filter}${item}=${filterObject[item]}&`
            }
        });
        return filter.slice(0, -1);
    }

    //GET RANGE TIME PRIOR CURRENT DATE
    getRangeDatesOfLastMonth = () => {
        let currentDate = new Date();
        let startDate = new Date(currentDate.setDate(currentDate.getDate() - 30));
        return { startDate: startDate.toISOString().split('T')[0], endDate: new Date().toISOString().split('T')[0] }
    }

    //TO BE FETCHED FROM BACKEND API
    TASKS_SUPERVISION_SOURCE_OPTIONS = [
        { label: 'All sources', key: 'all' },
        { label: 'Messenger', key: 'messenger', icon: this.guessSourceIcon('messenger') },
        { label: 'Linkedin', key: 'linkedin', icon: this.guessSourceIcon('linkedin') },
        { label: 'Instagram', key: 'instagram', icon: this.guessSourceIcon('instagram') },
        { label: 'Twitter', key: 'twitter', icon: this.guessSourceIcon('twitter') }
    ]

    bindTasksSupervisionSet = (data) => {
        return data.map(item => {
            switch (item.status) {
                case INTERVENTION_STATUS.INITIATED:
                    item['icon'] = "bi bi-bookmark-plus";
                    item['color'] = "gray";
                    break;
                case INTERVENTION_STATUS.ACCEPTED:
                    item['icon'] = "bi bi-bookmark-check";
                    item['color'] = "blue";
                    break;
                case INTERVENTION_STATUS.IN_PROGRESS:
                    item['icon'] = "bi bi-hourglass-top";
                    item['color'] = "#e74c3c";
                    break;
                case INTERVENTION_STATUS.COMPLETED:
                    item['icon'] = "bi bi-check-circle";
                    item['color'] = "#00bc8c"
                    break;
                case INTERVENTION_STATUS.ARCHIVED:
                    item['icon'] = "bi bi-archive";
                    item['color'] = "#f39c12";
                    break;
                case INTERVENTION_STATUS.ABORTED:
                    item['icon'] = "bi bi-x-circle";
                    item['color'] = "#343a40";
                    break;
                case INTERVENTION_STATUS.DEFFERRED:
                    item['icon'] = "bi bi-arrow-up-right-circle";
                    item['color'] = "#343a40";
                    break;
                default:
                    item['icon'] = "bi bi-bookmark";
                    item['color'] = "black";
                    break;
            }
            return item;
        })
    }

    GridLoader = () => {
        return <div className='mt-3' style={{ display: "grid", gridTemplateColumns: "25% 25% 25% 25%" }}>
            {[...Array(15)].map(() => <SkeletonLoader card factor={1} />)}
        </div>
    }

    /**
     * This to bind agent items to inject nested props such as explicit icon & color
     * @param {Array} items Agent statuses to be binded
     * @returns Array map of agent status
     */
    bindAgentStatusOptions = (items) => {
        return items.map((item) => {
            let AGENT_ST = AGENT_STATUS.filter(status => status.STATUS_ID === item.statusUserId)[0];
            return { id: item.statusUserId, icon: AGENT_ST?.ICON, value: item.description, color: AGENT_ST?.COLOR };
        });
    }

    /**
    * Capitalize first letter of given string
    * @param {string} str string to be capitalized
    * @returns capitalized string
    */
    capitalizeStr = (str) => {
        return `${str.charAt(0).toLocaleUpperCase()}${str.slice(1).toLocaleLowerCase()}`
    }

    /**
     * Retrieve color hex based index or randomly if it does not exists
     * @param {Integer} index of color
     * @returns color hex
     */
    randomSetColor = (index) => {
        let colors = [
            "#ca64ea",
            "#f2c811",
            "#007f9c",
            "#007acc",
            "#f08705",
            "#da2725",
            "#002966"
        ];
        return colors[index] ? colors[index] : colors[Math.floor(Math.random() * colors.length)];
    }

    /**
     * Check if the first char is within arabic lang
     * @param {String} val text to be regexed
     * @returns 
     */
    isArabicFirstChar = (val) => {
        const arabic = /[\u0600-\u06FF]/;
        return arabic.test(val ? val[0] : ``);
    }

    
}

export default new Utils();

//EXPORT CONSTANTS
export * from "./constants";
export * from "./jwt-worker";
